import React from 'react'
import { Row } from 'styled/alignment/Row'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import { Edit, Mail, Smartphone } from 'react-feather';
import Text from 'components/_UI/Text';

export default function UserDataCard({ data, onEdit = () => false }) {
    return (
        <Container>
            <Row>
               
                <Column>
                    <UserInfo>
                        <Column width='auto' height='auto' >
                            <DynamicProfileImage size='54px' word={data?.first_name} img={data?.avatar} />
                        </Column>

                        <UserContent>
                            <Text>{data?.first_name}</Text>
                            <Row>
                                <Mail size={14} color={colors.night} />
                                <Text marginLeft={'4px'}>{data?.email}</Text>
                            </Row>
                            {
                                data?.phone && 
                                <Row>
                                    <Smartphone size={14} color={colors.night} />
                                    <Text marginLeft={'4px'}>{ data.phone }</Text>
                                </Row>
                            }
                        </UserContent>
                        
                    </UserInfo>
                </Column>
                <StyledColumnButton>
                    <ContentButtonEdit>
                        <StyledEditButton onClick={onEdit}>
                            <Edit color={colors.occasionalPurple} size={15} />
                        </StyledEditButton> 
                    </ContentButtonEdit>
                </StyledColumnButton>
                    
            </Row>
            
            
        </Container>
           
    )
}


const Container = styled(Column)`
    justify-content: space-between;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 5px #ddd;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 10px 14px 14px 14px;
    align-items: center;
    margin: 4px 0 10px 0;

    
    
`;

const UserInfo = styled(Row)`
    align-items: center;    
    width: 95%;
`;

const UserContent = styled(Column)`
    margin-left: 14px;
    & > :first-child {
        word-break: break-all;
    }
    

`;

const StyledEditButton = styled.div`
    cursor: pointer;
    align-items: center;
   
`;

const ContentButtonEdit = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
`;

const StyledColumnButton = styled(Column)`
    width: 5%;
`

